import { Link } from 'react-router-dom'
import { ROUTES } from '@/utils/constants'

export default function Header() {
  return (
    <header className="bg-white shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to={ROUTES.HOME} className="text-2xl font-bold text-primary-600">
              PC Food Pantry
            </Link>
          </div>
          
          <div className="hidden md:flex space-x-8">
            <Link
              to={ROUTES.HOME}
              className="text-gray-700 hover:text-primary-600 transition-colors"
            >
              Home
            </Link>
            <Link
              to={ROUTES.ABOUT}
              className="text-gray-700 hover:text-primary-600 transition-colors"
            >
              About
            </Link>
            <Link
              to={ROUTES.MISSION}
              className="text-gray-700 hover:text-primary-600 transition-colors"
            >
              Mission
            </Link>
            <Link
              to={ROUTES.GET_HELP}
              className="text-gray-700 hover:text-primary-600 transition-colors"
            >
              Get Help
            </Link>
            <Link
              to={ROUTES.VOLUNTEER}
              className="text-gray-700 hover:text-primary-600 transition-colors"
            >
              Volunteer
            </Link>
            <Link
              to={ROUTES.BLOG}
              className="text-gray-700 hover:text-primary-600 transition-colors"
            >
              Blog
            </Link>
            <Link
              to={ROUTES.CONTACT}
              className="text-gray-700 hover:text-primary-600 transition-colors"
            >
              Contact
            </Link>
            <Link
              to={`${ROUTES.LOGIN}?next=${encodeURIComponent(ROUTES.ADMIN_TODAY)}`}
              className="text-gray-700 hover:text-primary-600 transition-colors"
            >
              Staff Login
            </Link>
          </div>
        </div>
      </nav>
    </header>
  )
}

